export const I_SOURCE = "iai_s";
export const I_MEDIUM = "iai_m";
export const I_CAMPAIGNID = "iai_caid";
export const I_CAMPAIGN = "iai_ca";
export const I_CONTENTID = "iai_coid"; // aggroup / set etc
export const I_TERM = "iai_t"; // term / keyword
export const I_ADID = "iai_adid"; // term / keyword
